var jQuery = require("jquery");
var $ = jQuery;
global.$ = jQuery;
global.jQuery = jQuery;
global.jquery = jQuery;
var slick = require('slick-slider');
var fancybox = require('fancybox')($);
global.fancybox = fancybox;

require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/tab');

// Cookies
var Cookies = require('js-cookie');
const { forEach } = require("lodash");
global.Cookies = Cookies;

$('.closeCookieNo').on('click', function () {
    $(this).closest('.cookies').hide();
    Cookies.set('cookie', 2);
});


$('.closeCookie').on('click', function () {
    $(this).closest('.cookies').hide();
    Cookies.set('cookie', 1, {
        expires: 365
    });
});

// RegistyChanges
$('.reqistryChangesBtn').on('click', function (e) {
    e.preventDefault();
    if ($('.reqistryChangesInner').is(':visible')) {
        $('.reqistryChangesInner').slideUp();
        $('.reqistryChangesBtnShow').show();
        $('.reqistryChangesBtnClose').hide();
    } else {
        $('.reqistryChangesInner').slideDown();
        $('.reqistryChangesBtnShow').hide();
        $('.reqistryChangesBtnClose').show();
    }
});

// show/more legal
$(".btn--more").on('click', function (e) {
    e.preventDefault();
    $('.complete').hasClass('d-none') ? $(this).text('czytaj mniej >>') : $(this).text("czytaj całość >>");
    $(this).siblings('.complete').toggleClass('d-none');
});

// Popup
if ($('.popup').length > 0) {
    setTimeout(function () {
        var popup = $('.popup--hidden');
        $(popup).removeClass('popup--hidden');
        $(popup).addClass('show');
    }, 600);

    $('#popupClose').on('click', function () {
        var popup = $('.popup');
        $(popup).removeClass('show');
        $(popup).addClass('hide');
    })
}


// Alerts
setTimeout(function () {
    $('.alerts-floating').find('.alert').fadeOut();
}, 5000);

$(document).on('click', '.alertClose', function () {
    $(this).closest('.alert').fadeOut();
})

$('.slider-home').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 1,
    draggable: true,
    swipeToSlide: true,
    focusOnSelect: true,
    mobileFirst: true,
    appendDots: $('.sliderNav .dots'),
});

$('.gallery-slider').slick({
    rows: 0,
    nextArrow: '<button class="slick-next"> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="17.757mm" height="31.151mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 17.757 31.151" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <path class="initial" d="M17.7571 15.5755c0,0.5583 -0.2132,1.1166 -0.6386,1.5422l-13.3945 13.3944c-0.8521,0.8521 -2.2336,0.8521 -3.0853,0 -0.8517,-0.8517 -0.8517,-2.2329 0,-3.085l11.8522 -11.8516 -11.8518 -11.8516c-0.8517,-0.852 -0.8517,-2.2331 0,-3.0847 0.8517,-0.8525 2.2332,-0.8525 3.0852,0l13.3946 13.3942c0.4255,0.4258 0.6382,0.9841 0.6382,1.5421z" /> </g> </svg> <span class="sr-only">Następny <span lang="en">slide</span></span> </button>',
    prevArrow: '  <button class="slick-prev"> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="17.757mm" height="31.151mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 17.757 31.151" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <path class="initial" d="M-0 15.5755c0,0.5583 0.2132,1.1166 0.6386,1.5422l13.3944 13.3944c0.852,0.8521 2.2335,0.8521 3.0852,0 0.8517,-0.8517 0.8517,-2.2329 0,-3.085l-11.8521 -11.8516 11.8517 -11.8516c0.8517,-0.852 0.8517,-2.2331 0,-3.0847 -0.8517,-0.8525 -2.2332,-0.8525 -3.0852,0l-13.3944 13.3942c-0.4255,0.4258 -0.6382,0.9841 -0.6382,1.5421z" /> </g> </svg> <span class="sr-only">Poprzedni <span lang="en">slide</span></span> </button>',
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [{
            breakpoint: 1024,
            settings: {
                arrows: true,
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 1,
                centerMode: false,
            }
        },
    ]
});

$('.clinic-slider').slick({
    rows: 0,
    nextArrow: '<button class="slick-next"> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="17.757mm" height="31.151mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 17.757 31.151" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <path class="initial" d="M17.7571 15.5755c0,0.5583 -0.2132,1.1166 -0.6386,1.5422l-13.3945 13.3944c-0.8521,0.8521 -2.2336,0.8521 -3.0853,0 -0.8517,-0.8517 -0.8517,-2.2329 0,-3.085l11.8522 -11.8516 -11.8518 -11.8516c-0.8517,-0.852 -0.8517,-2.2331 0,-3.0847 0.8517,-0.8525 2.2332,-0.8525 3.0852,0l13.3946 13.3942c0.4255,0.4258 0.6382,0.9841 0.6382,1.5421z" /> </g> </svg> <span class="sr-only">Następny <span lang="en">slide</span></span> </button>',
    prevArrow: '  <button class="slick-prev"> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="17.757mm" height="31.151mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 17.757 31.151" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <path class="initial" d="M-0 15.5755c0,0.5583 0.2132,1.1166 0.6386,1.5422l13.3944 13.3944c0.852,0.8521 2.2335,0.8521 3.0852,0 0.8517,-0.8517 0.8517,-2.2329 0,-3.085l-11.8521 -11.8516 11.8517 -11.8516c0.8517,-0.852 0.8517,-2.2331 0,-3.0847 -0.8517,-0.8525 -2.2332,-0.8525 -3.0852,0l-13.3944 13.3942c-0.4255,0.4258 -0.6382,0.9841 -0.6382,1.5421z" /> </g> </svg> <span class="sr-only">Poprzedni <span lang="en">slide</span></span> </button>',
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: '10px',
    centerMode: true,
    responsive: [{
            breakpoint: 1024,
            settings: {
                arrows: true,
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 1,
                centerMode: false,
            }
        },
    ]
});

$('.clinic__contact__slider').slick({
    rows: 0,
    nextArrow: '<button class="slick-next"> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="17.757mm" height="31.151mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 17.757 31.151" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <path class="initial" d="M17.7571 15.5755c0,0.5583 -0.2132,1.1166 -0.6386,1.5422l-13.3945 13.3944c-0.8521,0.8521 -2.2336,0.8521 -3.0853,0 -0.8517,-0.8517 -0.8517,-2.2329 0,-3.085l11.8522 -11.8516 -11.8518 -11.8516c-0.8517,-0.852 -0.8517,-2.2331 0,-3.0847 0.8517,-0.8525 2.2332,-0.8525 3.0852,0l13.3946 13.3942c0.4255,0.4258 0.6382,0.9841 0.6382,1.5421z" /> </g> </svg> <span class="sr-only">Następny <span lang="en">slide</span></span> </button>',
    prevArrow: '  <button class="slick-prev"> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="17.757mm" height="31.151mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 17.757 31.151" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <path class="initial" d="M-0 15.5755c0,0.5583 0.2132,1.1166 0.6386,1.5422l13.3944 13.3944c0.852,0.8521 2.2335,0.8521 3.0852,0 0.8517,-0.8517 0.8517,-2.2329 0,-3.085l-11.8521 -11.8516 11.8517 -11.8516c0.8517,-0.852 0.8517,-2.2331 0,-3.0847 -0.8517,-0.8525 -2.2332,-0.8525 -3.0852,0l-13.3944 13.3942c-0.4255,0.4258 -0.6382,0.9841 -0.6382,1.5421z" /> </g> </svg> <span class="sr-only">Poprzedni <span lang="en">slide</span></span> </button>',
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [{
            breakpoint: 1024,
            settings: {
                arrows: true,
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 1,
                centerMode: false,
            }
        },
    ]
});

 // Clinic Gallery
 $('.clinicMainSlider').slick({
    asNavFor: '.clinicThumbaSlider',
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    lazyLoad: 'ondemand',
    adaptiveHeight: false,
    arrows: false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Poprzednie"><svg viewBox="19.123 15.247 11.409 17.594" width="12.105" height="17.959"  xmlns="http://www.w3.org/2000/svg"> <polyline class="initial" points="28.01 31.21 24 27.6 19.99 24 24 20.4 28.01 16.79"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Następne"><svg viewBox="17.692 15.237 12.105 17.959" width="12.105" height="17.959" xmlns="http://www.w3.org/2000/svg"><polyline class="initial" points="19.99 16.79 24 20.4 28.01 24 24 27.6 19.99 31.21"/></svg></button>',
    responsive: [{
        breakpoint: 1024,
        settings: {
            // variableWidth: true,
        }
    }
],
});

$('.clinicThumbaSlider').slick({
    asNavFor: '.clinicMainSlider',
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    centerMode: false,
    verticalSwiping:true,
    arrows:false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Poprzednie"><svg viewBox="19.123 15.247 11.409 17.594" width="12.105" height="17.959"  xmlns="http://www.w3.org/2000/svg"> <polyline class="initial" points="28.01 31.21 24 27.6 19.99 24 24 20.4 28.01 16.79"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Następne"><svg viewBox="17.692 15.237 12.105 17.959" width="12.105" height="17.959" xmlns="http://www.w3.org/2000/svg"><polyline class="initial" points="19.99 16.79 24 20.4 28.01 24 24 27.6 19.99 31.21"/></svg></button>',
    mobileFirst: true,
    responsive: [{
            breakpoint: 0,
            settings: {
                slidesToShow: 3,
                vertical: false,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                vertical: true,
                variableWidth: false,
                infinite: false,
            }
        },
    ],
});



$(window).on('load', function () {
    console.debug('DOM loaded');
    // matchHeight('.top_content');
    var mobile = isMobile();

    let navigation = $('.navigation');
    $(window).on('resize', function () {
        mobile = isMobile();
        console.debug(mobile);

        if (!mobile) {
            navigation.hasClass('open') && navigation.removeClass('open');
            hideMenu(navigation);
        }
    });

    console.debug(mobile);

    // menu
    $('.btn--hamburger').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        navigation.toggleClass('open');
        navigation.hasClass('open') ? navigation.attr('aria-expanded', 'true') : navigation.attr('aria-expanded', 'false');
        navigation.hasClass('open') ? navigation.attr('tabindex', '0') : navigation.attr('tabindex', '-1');
        navigation.hasClass('open') ? navigation.find('#menuText').text('zwiń menu') : navigation.find('#menuText').text('rozwiń menu');
    })

    $('.btn-close').on('click', function (e) {
        e.preventDefault();
        hideMenu(navigation);
    });

    $('#page-navigation .navigation-list .link').on('click', function (e) {
        hideMenu(navigation);
    });

    $(document).on('keyup', function (e) {
        if (e.key == "Escape") hideMenu(navigation);
    });

    if (mobile) {
        $(".navigation-list a").on('click', function (event) {
            // Perform a reset - Remove the "clicked" class on all other menu items
            $that = $(this);
            $parent = $that.parent();
            $parent.addClass('open');
            console.debug($that);
            console.debug($parent);
            // $(".item").not($parent.parent()).removeClass("open");
            $(".hasSub").not($that).removeClass("clicked");
            if ($($that).hasClass('hasSub')) {
                $($that).toggleClass("clicked");
                $($that).siblings('.dropdown-menu').toggleClass('open');
            }
            if ($($that).hasClass("clicked")) {
                event.preventDefault();
            }
        });

        $(".navigation-list dropdown").on('click', function (event) {
            // Perform a reset - Remove the "clicked" class on all other menu items
            $(".item").not(this).removeClass("open");
            $(".hasSub").not(this).removeClass("clicked");
            if ($(this).hasClass('hasSub')) {
                $(this).toggleClass("clicked");
                $(this).siblings('.dropdown-menu').toggleClass('open');
            }
            if ($(this).hasClass("clicked")) {
                event.preventDefault();
            }
        });
    }

    // kayboard focus tab
    $(document).on('focus', '.navigation-list .item a', function () {
        $that = $(this);
        $parent = $that.parent();
        $('.item').removeClass('active');
        $parent.addClass('active');
        if ($(this).closest('.focus').length <= 0) {
            $('.dropdown-menu').removeClass("focus");
            $parent.prev().removeClass('active');
        }
        if ($(parent).hasClass('.active').length > 0) {
            $parent.prev().removeClass('active open');
        }
        $parent.prev().removeClass('focus');
        $parent.prev().removeClass('active');
        if ($(this).hasClass('hasSub')) {
            $(this).siblings().addClass('focus');
            if ($(this).hasClass('hasSub')) {
                $(this).siblings().addClass('focus');
            }
        }
    });

    $(document).on('focusout', '.navigation-list .item a', function () {
        $('.navigation-list .item').hasClass('active') && $('.navigation-list .item').removeClass('active');
    });

    $(document).on('mouseup', function (e) {
        var container = $('.focus');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass("focus");
        }
    });

    $('.linkDropdown').on('mouseenter', function () {
        $(this).addClass('open')
    }).on('mouseleave', function () {
        $(this).removeClass('open')
    });

    // end menu

    $(".showBtnMore").on('click', function (e) {
        e.preventDefault();

        const that = $(this);
        that.toggleClass('show');
        that.hasClass('show') ? that.attr('aria-expanded', 'true') : that.attr('aria-expanded', 'false');
        that.find('.icon').toggleClass('rotate');

        if(that.hasClass('show')){
            $(that).find('.showBtnMoreClose').show()
            $(that).find('.showBtnMoreShow').hide();
        } else{
            $(that).find('.showBtnMoreClose').hide()
            $(that).find('.showBtnMoreShow').show();
        }

        parent = that.parent();

        lists = parent.find('ul');
        lists_items = lists.find('li[data-hide="true"]');

        $( '.services__list li a ').trigger('focus');

        $(lists_items).each(function () {
            $(this).toggleClass('d-none');
        });

    });


    $(".BtnShowPhone").on('click', function (e) {

        const that = $(this);

        if(that.hasClass('show')){
            window.location = $(this).attr('href');
        }

        e.preventDefault();
        const phone = that.attr('data-phone');
        $(that).attr("href", "tel:" + phone + '');
        $(that).text(phone);
        $(that).addClass('show');


    });

    const select = $('#selectClinics');

    if(select){
        const btn = $('.selectGoTo');
        btn.attr("href",  select.children('option:selected').data('href'));

        select.on('change',function(){
            const link = $(this).children('option:selected').data('href');
            console.debug(link);
            $('.selectGoTo').attr("href", link);
          });
    }


    $(".navigation-list dropdown").on('click', function (event) {
        // Perform a reset - Remove the "clicked" class on all other menu items
        $(".hasSub").not(this).removeClass("clicked");
        if ($(this).hasClass('hasSub')) {
            $(this).toggleClass("clicked");
            $(this).siblings('.dropdown-menu').toggleClass('open');
        }
        if ($(this).hasClass("clicked")) {
            event.preventDefault();
        }
    });

    const $slider = $('.slider-home');

    if ($slider) {

        $(".sliderNav .slick-prev").on('click', function (e) {
            e.preventDefault();
            $slider.slick('slickPrev');
        });

        $(".sliderNav .slick-next").on('click', function (e) {
            e.preventDefault();
            $slider.slick('slickNext');
        });

        $(".sliderNav .slick-pause").on('click', function (e) {
            e.preventDefault();
            const $that = $(this);
            console.debug($that);

            if ($that.hasClass('play')) {
                $slider
                    .slick('slickPause')
                    .slick('slickSetOption', 'pauseOnDotsHover', false)
                    .slick('slickSetOption', 'autoplay', false);
                $that.toggleClass('pause play');
                $that.find('.sr-only').get(0).innerHTML = 'Wznów przwijanie <span lang="en">slidera</span>';
                $that.find('.text').get(0).innerHTML = 'Wznów';
            } else {
                $slider
                    .slick('slickPlay')
                    .slick('slickSetOption', 'pauseOnDotsHover', true)
                    .slick('slickSetOption', 'autoplay', true);
                $that.toggleClass('play pause');
                $that.find('.sr-only').get(0).innerHTML = 'Zatrzymaj przwijanie <span lang="en">slidera</span>';
                $that.find('.text').get(0).innerHTML = 'Zatrzymaj';
            }

        });
    }
});

$(".fancybox").fancybox({});


function hideMenu(navigation) {
    if (!navigation) return;
    navigation.removeClass('open');
    navigation.hasClass('open') ? navigation.attr('aria-expanded', 'true') : navigation.attr('aria-expanded', 'false');
    navigation.hasClass('open') ? navigation.attr('tabindex', '0') : navigation.attr('tabindex', '-1');
    $('.navigation-menu').collapse('hide');
}

function isMobile() {
    const $window = $(window).width();
    if ($window <= 767) {
        return true;

    } else {
        return false;
    }
}

function matchHeight($elem) {
    if (!$elem) return
    let maxHeight = 0;
    $($elem).each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
        console.debug($elem);
        $($elem).height(maxHeight);
    });
}
